const FAILURE_KEY = 'addressQualification_failures';
export function getFailureCount(): number {
  return Number(localStorage.getItem(FAILURE_KEY) ?? 0);
}
export function incrementFailureCount(): number {
  const count = getFailureCount() + 1;
  localStorage.setItem(FAILURE_KEY, count.toString());
  return count;
}
export function resetFailureCount(): void {
  localStorage.removeItem(FAILURE_KEY);
}